import { dateUtils } from '../../../shared/lib';
import { appLocale } from '../../../shared/model';
import { LocationType, type MappedLocation } from '../../../shared/types';

const emptyCity = {
  code: '',
  name: '',
  name_ru: '',
  name_en: '',
  name_kk: '',
  type: LocationType.CITY,
  country: {
    code: '',
    name: '',
    name_ru: '',
    name_en: '',
    name_kk: '',
    type: LocationType.COUNTRY,
  },
} as const;

const locale = appLocale.lib.getAppLocale();

const getLocalizedCityName = (city: MappedLocation): string => {
  return city[`name_${locale}`] || city.name || '';
};

const formatSearchCities = (
  dep: MappedLocation = emptyCity,
  arr: MappedLocation = emptyCity,
) => {
  return {
    dep: {
      value: getLocalizedCityName(dep),
      suffix: ` ${dep.code}`,
    },
    arr: {
      value: getLocalizedCityName(arr),
      suffix: ` ${arr.code}`,
    },
  };
};

const formatSearchDate = (dates: string[]) => {
  return dates.map(date => ({
    value: dateUtils.getVerbalDate(date),
    suffix: `, ${dateUtils.getPrettyDayOfWeek(date)}`,
  }));
};

export const formatterLib = {
  formatSearchCities,
  formatSearchDate,
};
